import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import Macy from 'macy';

Swiper.use([Autoplay, Navigation, Pagination]);

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            // this.initInspiration();
            this.initReferenties();
        }
    }

    // initInspiration() {
    //     const macy = Macy({
    //         container: '#inspiratieContainerHome',
    //         trueOrder: false,
    //         waitForImages: false,
    //         margin: 27,
    //         columns: 2,
    //         breakAt: {
    //            768:{
    //                columns: 1,
    //                margin: {
    //                    x: 15,
    //                    y: 15,
    //                },
    //            }
    //         }
    //     });
    // }

    initReferenties() {
        new Swiper('#referentieSlider .swiper-container', {
            sliderPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000,
            },
            navigation: {
                nextEl: ".nav-arrow",
            },
        });
    }
}
